import { useMemo } from 'react';
import { Participant } from '../../../types';

type LeaderboardTab = 'participants' | 'areas' | 'offices';

interface LeaderboardParticipant extends Participant {
  rank: number;
  area: string;
  avatar?: string;
}

const mapToViewModel = (p: any): LeaderboardParticipant => ({
  id: p.id,
  rank: p.rank,
  name: `${p.firstName} ${p.lastName}`,
  area: p.districtNames || '',
  position: p.rank,
});

export const useLeaderboardCurrentData = (
  activeTab: LeaderboardTab,
  participantRows: any[],
  areaRows: any[],
  officeRows: any[],
  participantsPage: number,
  myParticipant: any,
  participants: any[],
  pageSize: number
) => {
  return useMemo(() => {
    if (activeTab === 'participants') {
      let baseRows = participantRows;

      if (!myParticipant) return baseRows;

      const presentInApiPage = (participants || []).some((p) => p.id === myParticipant.id);
      if (presentInApiPage) return baseRows;

      const myPage = Math.max(1, Math.ceil(myParticipant.rank / (pageSize || 10)));
      const myRow = mapToViewModel(myParticipant);
      if (myPage > participantsPage) return [...baseRows, myRow];
      if (myPage < participantsPage) return [myRow, ...baseRows];
      return [...baseRows, myRow];
    }
    if (activeTab === 'areas') return areaRows;
    return officeRows;
  }, [
    activeTab,
    participantRows,
    participantsPage,
    areaRows,
    officeRows,
    myParticipant,
    participants,
    pageSize,
  ]);
};
